import { businessKey } from 'queryKeys';

const MARKETING_PLANNING = 'marketingPlanning';
const ERROR_LOG = 'errorLog';
const MUTATION_IMPORT_FROM_GOOGLE_DRIVE = 'importGoogleDrive';
const MUTATION_EXPORT_FROM_GOOGLE_DRIVE = 'exportGoogleDrive';
const MUTATION_ADD_FROM_GOOGLE_DRIVE = 'addGoogleDrive';
const MUTATION_IMPORT_NEW_FROM_GOOGLE_DRIVE = 'importNewGoogleDrive';
const MUTATION_IMPORT_CSV = 'importCSV';
const MUTATION_IMPORT_NEW_CSV = 'importNewCSV';
const MUTATION_EXPORT_CSV = 'exportCSV';

const mpQuery = businessKey.query(MARKETING_PLANNING);

export const errorLog = mpQuery.next(ERROR_LOG);

export const mutations = mpQuery.mutations();

export const importFromGoogleDrive = mutations.mutate(
  MUTATION_IMPORT_FROM_GOOGLE_DRIVE
);
export const importCSV = mutations.mutate(MUTATION_IMPORT_CSV);
export const importNewCSV = mutations.mutate(MUTATION_IMPORT_NEW_CSV);
export const exportGoogleDrive = mutations.mutate(
  MUTATION_EXPORT_FROM_GOOGLE_DRIVE
);
export const exportCSV = mutations.mutate(MUTATION_EXPORT_CSV);
export const addFromGoogleDrive = mutations.mutate(
  MUTATION_ADD_FROM_GOOGLE_DRIVE
);
export const importNewFromGoogleDrive = mutations.mutate(
  MUTATION_IMPORT_NEW_FROM_GOOGLE_DRIVE
);
